import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../../macroscopia.action';
import * as commonActions from '@common/common.action';
import FrascosPage from './frascos.page';
import WebapiCommon from '@common/util/webapi.common';
import { acessoPermitido } from '../../../../../../acessos.seguranca';
import { editorRunat, editorUrl } from '@constants/defaultValues';

const FrascoContainer = ({ altura }) => {
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.usuario);
  const detalhes = useSelector(state => state.commonReducer.detalhes);

  const [frascos, setFrascos] = useState([]);
  const [blocosSelecionados, setBlocosSelecionados] = useState([]);
  const [todosBlocos, setTodosBlocos] = useState([]);
  const [existeBloco, setExisteBloco] = useState(false);
  const [all, setAll] = useState(true);

  useEffect(() => {

    dispatch(actions.showFadeCarregando(true));
    WebapiCommon.getListagemFrascos(detalhes.laudo).then(resp => {
      setFrascos(resp);
      var array = [];
      // eslint-disable-next-line array-callback-return
      resp.map(item => {
        array = [...array, ...item.blocos];
      });

      setBlocosSelecionados(array);
      setTodosBlocos(array);

      setExisteBloco(
        resp.find(f => f.blocos.find(t => t !== null)) !== undefined
      );
      dispatch(actions.showFadeCarregando(false));
    });
  }, []);

  useEffect(() => {
    setAll(blocosSelecionados.length === todosBlocos.length);
  }, [blocosSelecionados, todosBlocos]);

  const obterFrascos = () => {
    const blocosRequest = blocosSelecionados.filter(b => b !== null);
    if (!blocosRequest.length) {
      dispatch(
        commonActions.showAlerta(
          'alerta',
          'Selecione ao menos 1 bloco da lista para inserir',
          3000,
          '500px'
        )
      );
      return;
    }

    dispatch(actions.showFadeCarregando(true));
    WebapiCommon.inserirMapaLaudo(detalhes.laudo, blocosRequest).then(texto => {
      const frame = document.getElementById('iframe-editor');
      texto.texto.forEach(t => {
        if (t) {
          let texRtfBase64 = btoa(t);
          frame.contentWindow.postMessage(
            {
              method: 'inserirTexto',
              text: texRtfBase64,
              type: 'rtf',
              runat: editorRunat,
              breakLine: false,
              paragraph: true
            },
            editorUrl
          );
        }
      });
      dispatch(actions.showFadeCarregando(false));
    });
  };

  const onClick = nrBloco => {
    const index = blocosSelecionados.indexOf(nrBloco);
    let _selecionados = [...blocosSelecionados];

    if (index === -1) {
      _selecionados.push(nrBloco);
    } else {
      _selecionados.splice(index, 1);
    }
    setBlocosSelecionados(_selecionados);
  };

  const onClickAll = () => {
    setAll(!all);
    if (!all) {
      setBlocosSelecionados(todosBlocos);
    } else {
      setBlocosSelecionados([]);
    }
  };

  return (
    <FrascosPage
      usuario={usuario}
      altura={altura}
      frascos={frascos}
      existeBloco={existeBloco}
      obterFrascos={obterFrascos}
      acessoPermitido={acessoPermitido}
      onClick={onClick}
      blocosSelecionados={blocosSelecionados}
      all={all}
      onClickAll={onClickAll}
    />
  );
};

export default FrascoContainer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/tabs/frascos/frascos.container.js